import React, { useContext } from 'react';
import { ApiContext } from '@api/api';
import { InheritedModuleOutDTO } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import SectionPanel from '@components/framework/panels/SectionPanel.tsx';
import RingilDataTable, { ColumnConfig } from '@components/RingilDataTable/RingilDataTable.tsx';
import SvgBox from '@icons/box.svg?react';

interface ComponentProps {
  customerId: string;
}

const AdminInheritedModules: React.FC<ComponentProps> = ({ customerId }) => {
  const { getModulesInheritedForCompany } = useContext(ApiContext);
  const { tr } = useTranslationLgs();

  const columnConfig: ColumnConfig<InheritedModuleOutDTO>[] = [
    {
      id: 'moduleName',
      header: 'adminCompanyDetail.moduleType',
      headerDefault: 'Module type',
      verticalAlign: 'middle',
      render: row => <div>{row.moduleName}</div>,
    },
    {
      id: 'inheritedFromCompanyName',
      header: 'adminCompanyDetail.inheritedFromCompany',
      headerDefault: 'Inherited from company',
      verticalAlign: 'middle',
      render: row => <div>{row.inheritedFromCompanyName}</div>,
    },
  ];

  return (
    <SectionPanel
      icon={<SvgBox className={'w-6 h-6'} />}
      iconColor={'var(--content-tertiary)'}
      heading={tr('adminCompanyDetail.inheritedModules', 'Inherited modules')}
      dataTestId={'admin-company-section-inheritedModules'}>
      <RingilDataTable
        columnConfig={columnConfig as ColumnConfig<unknown>[]}
        filterName={'admin_company_inherited_modules'}
        hidePaginator={true}
        loadDataFromApi={(filter, pageable, onSuccess) =>
          getModulesInheritedForCompany(customerId, d => onSuccess({ data: d, total: d?.length ?? 0, page: 1, size: d?.length ?? 0 }))
        }
      />
    </SectionPanel>
  );
};

export default AdminInheritedModules;
